export const abbreviateString = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) {
    return str;
  }
  const truncated = str.substring(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(' ');
  if (lastSpaceIndex > 0) {
    return `${truncated.substring(0, lastSpaceIndex)} ...`;
  }
  return `${truncated} ...`;
};
